import { render, staticRenderFns } from "./CadHorarios.vue?vue&type=template&id=2c4f4a5f"
import script from "./CadHorarios.vue?vue&type=script&lang=js"
export * from "./CadHorarios.vue?vue&type=script&lang=js"
import style0 from "./CadHorarios.vue?vue&type=style&index=0&id=2c4f4a5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports